import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  STAFF_CONTACT_TYPE_LIST, STAFF_CONTACT_TYPE_CREATE,
  STAFF_CONTACT_TYPE_UPDATE, STAFF_CONTACT_TYPE_DELETE,
  STAFF_CONTACT_LIST, STAFF_CONTACT_CREATE,
  STAFF_CONTACT_UPDATE, STAFF_CONTACT_DELETE,
} from "./actionType";
import {
  staffContactTypeListSuccess, staffContactTypeListFailure,
  staffContactTypeCreateSuccess, staffContactTypeCreateFailure,
  staffContactTypeUpdateSuccess, staffContactTypeUpdateFailure,
  staffContactTypeDeleteSuccess, staffContactTypeDeleteFailure,
  staffContactListSuccess, staffContactListFailure,
  staffContactCreateSuccess, staffContactCreateFailure,
  staffContactUpdateSuccess, staffContactUpdateFailure,
  staffContactDeleteSuccess, staffContactDeleteFailure,
} from "./action";
import {
  staffContactTypeListApi, staffContactTypeCreateApi,
  staffContactTypeUpdateApi, staffContactTypeDeleteApi,
  staffContactListApi, staffContactCreateApi,
  staffContactUpdateApi, staffContactDeleteApi,
} from "../../helpers/fakebackend_helper";

// FetchAPI resolves to the parsed body, so `response` is what the reducer
// wants — see Task 24465 for what testing `response.data` here costs.
function* handleTypeList()             { try { yield put(staffContactTypeListSuccess(yield call(staffContactTypeListApi)));             } catch (e) { yield put(staffContactTypeListFailure(e)); } }
function* handleTypeCreate({ payload }){ try { yield put(staffContactTypeCreateSuccess(yield call(staffContactTypeCreateApi, payload))); } catch (e) { yield put(staffContactTypeCreateFailure(e)); } }
function* handleTypeUpdate({ payload }){ try { yield put(staffContactTypeUpdateSuccess(yield call(staffContactTypeUpdateApi, payload))); } catch (e) { yield put(staffContactTypeUpdateFailure(e)); } }
function* handleTypeDelete({ payload }){ try { yield put(staffContactTypeDeleteSuccess(yield call(staffContactTypeDeleteApi, payload))); } catch (e) { yield put(staffContactTypeDeleteFailure(e)); } }

function* handleList({ payload })      { try { yield put(staffContactListSuccess(yield call(staffContactListApi, payload)));             } catch (e) { yield put(staffContactListFailure(e)); } }
function* handleCreate({ payload })    { try { yield put(staffContactCreateSuccess(yield call(staffContactCreateApi, payload)));         } catch (e) { yield put(staffContactCreateFailure(e)); } }
function* handleUpdate({ payload })    { try { yield put(staffContactUpdateSuccess(yield call(staffContactUpdateApi, payload)));         } catch (e) { yield put(staffContactUpdateFailure(e)); } }
function* handleDelete({ payload })    { try { yield put(staffContactDeleteSuccess(yield call(staffContactDeleteApi, payload)));         } catch (e) { yield put(staffContactDeleteFailure(e)); } }

export default function* StaffContactSaga() {
  yield all([
    fork(function* () { yield takeEvery(STAFF_CONTACT_TYPE_LIST, handleTypeList); }),
    fork(function* () { yield takeEvery(STAFF_CONTACT_TYPE_CREATE, handleTypeCreate); }),
    fork(function* () { yield takeEvery(STAFF_CONTACT_TYPE_UPDATE, handleTypeUpdate); }),
    fork(function* () { yield takeEvery(STAFF_CONTACT_TYPE_DELETE, handleTypeDelete); }),
    fork(function* () { yield takeEvery(STAFF_CONTACT_LIST, handleList); }),
    fork(function* () { yield takeEvery(STAFF_CONTACT_CREATE, handleCreate); }),
    fork(function* () { yield takeEvery(STAFF_CONTACT_UPDATE, handleUpdate); }),
    fork(function* () { yield takeEvery(STAFF_CONTACT_DELETE, handleDelete); }),
  ]);
}
